import { Card, Modal, Typography } from "@mui/material";
import EmojiPicker from "emoji-picker-react";
import React from "react";
import useThemeContext from "../../config/contexts/ThemeContext";
import { StyledModalContainer } from "../../pages/Layout/styles";
import {
  StyledEmojiSelector,
  StyledEmojiWrapper,
  StyledTextWrapper,
} from "./styles";

const EmojiPickerModal = ({
  onEmojiSelect,
  value = "",
  error = "",
  title = "Select emoji: ",
  onTouch = () => {},
}) => {
  const { colors } = useThemeContext();
  const [isVisible, setIsVisible] = React.useState(false);
  const closeModal = () => setIsVisible(false);
  const openModal = () => setIsVisible(true);
  const onChange = (emojiObject) => {
    onTouch();
    onEmojiSelect(emojiObject.emoji);
    setIsVisible(false);
  };
  return (
    <>
      <StyledEmojiWrapper>
        <StyledTextWrapper>
          <Typography>{title}</Typography>
          <Typography variant="caption" color="error">
            {error}
          </Typography>
        </StyledTextWrapper>
        <Card variant="outlined">
          <StyledEmojiSelector onClick={openModal}>
            <Typography variant="h4">{value || "-"}</Typography>
          </StyledEmojiSelector>
        </Card>
      </StyledEmojiWrapper>
      <Modal open={isVisible} onClose={closeModal}>
        <StyledModalContainer>
          <EmojiPicker onEmojiClick={onChange} theme={colors.theme} />
        </StyledModalContainer>
      </Modal>
    </>
  );
};

export default EmojiPickerModal;
